/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { ParamValueModel } from '../../../../../models/ParamValueModel';

@Component({
  selector: 'app-more-details',
  templateUrl: './app-more-details.html',
  styleUrls: ['./app-more-details.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMoreDetails implements OnInit, OnChanges {
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() os;
  @Input() isFollowing: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() toAppDiscovery: EventEmitter<ParamValueModel> =
    new EventEmitter<ParamValueModel>();
  @Output() followClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  tooltipTemplate =
    '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner email"></div></div>';
  deviceTypes = [
    {
      name: 'smartphone',
      tooltip:
        'Combined advertiser risk for the App on Smartphones by business region'
    },
    {
      name: 'tablet',
      tooltip:
        'Combined advertiser risk for the App on Tablets by business region'
    }
  ];
  tooltip: any = {
    appSpoofing: 'Ad Inventory from the App is Frequently Spoofed',
    inactiveApp: 'App is No Longer in Active Use',
    highRisk: 'Variety of Suspicious App Characteristics',
    datacenter: 'High Volumes of Datacenter Traffic Detected',
    newApp: 'Limited History of Low Risk Advertising Traffic',
    vpnApp: 'The App is a VPN',
    locationSpoofing:
      'Location Coordinates from the App are Commonly Inaccurate or Spoofed',
    highRiskDeveloper:
      'An app that belongs to a developer that has created one or more blacklisted apps.',
    IABcrawler: 'Significantly Elevated IVT Percentage',
    IABdummyBot: 'Significantly Elevated IVT Percentage'
  };
  isPopup: boolean;

  ngOnInit() {
    setTimeout(() => {
      this.isPopup = top !== self;
    }, 100);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      const { blackListAppReasonCode } = this.data.appOverview;
      if (
        blackListAppReasonCode &&
        blackListAppReasonCode !== 'N/A' &&
        Array.isArray(blackListAppReasonCode)
      ) {
        const reasonCodeArr = [];
        for (const code of blackListAppReasonCode) {
          reasonCodeArr.push(this.tooltip[code] ? this.tooltip[code] : code);
        }
        this.data.appOverview.blackListAppReasonCodeHtml =
          reasonCodeArr.join('<br/>');
      }
    }
  }

  goToSection(anchor: string) {
    this.anchorClick.emit(anchor);
  }

  getSellerParam(trustedSellerName: string) {
    return encodeURIComponent('trustedSellerName=' + trustedSellerName);
  }

  goToAppDiscovery(param: string, paramValue: string) {
    this.toAppDiscovery.emit({ param: param, paramValue: paramValue });
  }

  follow(): void {
    this.followClick.emit(true);
  }
}
